// The platform version this admin UI was built as: the deployed commit's
// `platform/<x.y.z>` tag (infra/scripts/next-platform-version.sh), passed to
// the image build by deploy-dedicated.sh. A local `vite` run has neither.

export function formatPlatformVersion(
  version: string | undefined,
  buildId: string | undefined,
): string {
  const v = version !== undefined && version.length > 0 ? version : '0.0.0-dev';
  const b = buildId !== undefined && buildId.length > 0 ? buildId : 'dev';
  return `v${v} · ${b}`;
}

export const platformVersionLabel: string = formatPlatformVersion(
  import.meta.env.VITE_APP_VERSION,
  import.meta.env.VITE_BUILD_ID,
);
